/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { ChatBotAPI } from '../../services/chatBotAPI';

@inject(AuthService, Router, ChatBotAPI, UserMessageService)
export class Chatbot {
  constructor(authService, router, api, userMessageService) {
    this.enableBtn = document.getElementById('enable-btn');
    this.consentModal = document.getElementById('consent-modal');
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.userMessageService = userMessageService;
    this.show_email=false;
    this.is_vendasta_reseller=0;
    this.saving = false;
    this.password1 = null;
    this.password2 - null;
    this.email1 = null;
    this.user_email = "";
    this.email2 = null;
    this.email_signature = "";
    this.email_signature_text = "";
    this.email_signature_status = false;
    this.isdashboard = false;
    this.dashboardlength = 'col-sm-12';
    this.rout = "";
    this.rout =(localStorage.getItem('rout'))? localStorage.getItem('rout') : "";
    this.is_vendasta_user = false;
    if(localStorage.getItem('tp_nav_url')){
        this.is_vendasta_user = true;
    }
    this.vendasta_user_logo = false;
    this.is_register_disabled = (window.is_register_disabled == 1) ? true : false;
    this.is_admin = this.authService.getUser().role === 'ADMIN';
  }

  attached() {
  }
  showModal() {
    $('#exampleModal').modal({
      backdrop: 'static', // Prevent closing on outside click
      keyboard: false     // (Optional) Prevent closing via "Esc" key
    });
  }
  activate(params) {
    console.log('logo::', params.logo);
    if(params.logo == 0){
        this.vendasta_user_logo = true;
    }
    this.showLogoUpload = false;
    this.showLogoUpload2 = false;
    this.loading = true;
    this.defaultBusinessType = 'Select...';
    this.load();
  }

  remove() {
    this.isEnableChatbot = false;
  }
  showVideoChatBotDetail() {
    this.isEnableChatbot = true;
    $('#exampleModal').modal('hide');
  }

  load() {
    this.api.getChatbotDetail(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  save() {
    if (this.validate()) {
      this.saving = true;
      this.api.save(
        this.getData(),
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this)
    );
    }
  }

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }

    this.saving = false;

    //console.log(this.showLogoUpload2 +"<------>"+ this.logoPath2);
  }

  saveLoadError(msg) {
    // this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }

  setData(data) {
    // Note: Keep this method in sync with similar code in affiliate.js
    console.log("account data",data);
    // Basic account fields
    this.website = data.website;    
    this.isEnableChatbot = (data.website) ? true : false;    
  }

  getData() {
    const data = {
      'owner_user_id': this.authService.getUser().id,
      'website': this.website,
      'isEnableChatbot': this.isEnableChatbot,
    };

    return data;
  }


  validate() {
    var pass = true;
    if (!this.website || this.isEnableChatbot != true) {
        if(!this.website) this.userMessageService.setUserError('user', 'Please Enter Website URL');
        if(this.isEnableChatbot != true) this.userMessageService.setUserError('user', 'Please Checked Is Enable Chatbot');
      pass = false;
    }

    return pass;
  }


  showVideoClicked(url) {
    this.showVideo = true;
    this.videoPlayer.src = url;
    this.videoPlayer.load();
    this.videoPlayer.play();
  }

  showVideoClosed() {
      this.showVideo = false;
      if (this.videoPlayer) {
          this.videoPlayer.pause();
      }
  }


  onNavigate() {
    this.navPanelClass = '';
  }

  navigateLink(route, replace = false) {
    console.log("route param",route);
    localStorage.setItem('rout', route);
    if(route.includes("#/user/home") || route == "#/user" || route == "#/user/account" || route.includes("#/user/video/request") || route.includes("#/user/video/caseStudy") || route.includes("#/user/video/email"))
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9';
      console.log("Dashboard value is",this.isdashboard);
    }
    if(route.includes("#/user/video/email"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=3" + "?videoUpload=1";
      else
      route = route + "?captureType=3";
      // window.location.href = "Posts?Category=" + sel;
    }


    this.router.navigate(route, { replace: replace });
    this.onNavigate();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

}
